import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ zone, filter }) =>
    present(
      repository
        .getZoneProjects(zone, filter)
        .then((projects) => ({ zone, filter, projects }))
        .catch((error) => Promise.reject({ error, zone, filter })),
    );
}

export type { Interactor };

export { createInteractor };
